import React from 'react';
import PropTypes from 'prop-types';
import AddButton from './AddButton';

export default function AddButtonView({ id, onSubmit, isDisabled, moreButtons }) {
    return (
        <div className="spark-pad-1">
            <AddButton id={`${id}-add-button`} isDisabled={isDisabled} submitAction={onSubmit} />
            {moreButtons}
        </div>
    );
}

AddButtonView.propTypes = {
    id: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    moreButtons: PropTypes.node
};

AddButtonView.defaultProps = {
    isDisabled: false,
    moreButtons: null
};



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/AddButtonView.js